export default __webpack_public_path__ + "media/images/app-icon-6687fc8dc08a2ec1b8de803bebb9f22e.svg";